import {
  BasicButton,
  ButtonGroup,
  PrimaryButton,
  Stack,
  Text,
} from "@certn/cascadia";
import { Illustration, Layout } from "@certn/cascadia-react";
import { Trans } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import { AppHeader } from "../../components/app-header";

export function InteracSessionCompleteOrCancelled() {
  const [searchParams] = useSearchParams();

  const error = searchParams.get("error");
  const errorDescription = searchParams.get("error_description");

  const cancelledDescriptions = [
    "User cancelled",
    "cancelled",
    "annul",
    "cancel",
  ];

  const otherError = error;

  const sessionCancelled = (
    cancelledDescriptions: string[],
    errorDescription: string | undefined
  ) =>
    cancelledDescriptions.some(
      (description) => description === errorDescription
    );

  const isCancelled = errorDescription
    ? sessionCancelled(cancelledDescriptions, errorDescription)
    : false;

  const handleClose = () => {
    window.opener?.focus();
    window.close();
  };

  return (
    <Layout
      layout="auth"
      header={<AppHeader showLoginButton={false} hideSettings />}
    >
      <>
        {otherError ? (
          <Stack gap="space-6" align="center">
            <Illustration name="verification-fail" />
            <Text style="form/page-title-mobile" align="center">
              {isCancelled ? (
                <Trans>
                  You have cancelled your identity verification session.
                </Trans>
              ) : (
                <Trans>
                  Something went wrong with your identity verification session.
                </Trans>
              )}
            </Text>
            <Text style="form/body-primary" color="text-weak" align="center">
              <Trans>Please try again to submit your application.</Trans>
            </Text>
            <div style={styles.buttonContainer}>
              <ButtonGroup>
                <BasicButton
                  type="button"
                  size="medium"
                  onPress={handleClose}
                  testID="close-button"
                >
                  <Text style="global/button-medium" color="text-base">
                    <Trans>Close</Trans>
                  </Text>
                </BasicButton>
                <PrimaryButton
                  type="button"
                  size="medium"
                  onPress={handleClose}
                  testID="close-button"
                >
                  <Text style="global/button-medium" color="text-inverse">
                    <Trans>Retry</Trans>
                  </Text>
                </PrimaryButton>
              </ButtonGroup>
            </div>
          </Stack>
        ) : (
          <Stack gap="space-6" align="center">
            <Illustration name="verification-success" />
            <Text style="form/page-title-mobile" align="center">
              <Trans>
                Thank you for completing your identity verification.
              </Trans>
            </Text>
            <Text style="form/body-primary" color="text-weak" align="center">
              <Trans>
                Please return to the applicant portal to submit your
                application.
              </Trans>
            </Text>
            <div style={styles.buttonContainer}>
              <PrimaryButton
                type="button"
                size="medium"
                onPress={handleClose}
                testID="close-button"
              >
                <Text style="global/button-medium" color="text-inverse">
                  <Trans>Close</Trans>
                </Text>
              </PrimaryButton>
            </div>
          </Stack>
        )}
      </>
    </Layout>
  );
}

const styles = {
  buttonContainer: {
    padding: "var(--space-4)",
  },
};
